import React from 'react';
import Utils from '../providers/Utils';
import { Fab, Hidden, Button, Divider, Avatar, IconButton, Grid } from '@material-ui/core';
import PropTypes from 'prop-types'
import Ws from '../providers/Ws';
import TaskMenu from './TaskMenu';
import ChangeEtapaViewMenu from './ChangeEtapaViewMenu';
import TabelTask from './TabelTask';
import SpecificComponent from './SpecificComponent';


export default class GanttTaskuriFullView extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            slideValue: 0,
        }
    }

    componentDidMount() {
    }

    ws = new Ws()
    taskData = {}
    elData = {}
    u = new Utils()


    callBack = (c) => {
        // console.log('c.value :>> ', c);

        if (c.id === 1) {

            let tEt = this.props.objTaskSelectat

            tEt['durata_de_la'] =  this.u.ParseDataFromSql(tEt['cand_data'])
            tEt['durata_pana_la'] = this.u.ParseDataFromSql(tEt['pana_cand_data'])

            this.props.editTask(c.task, tEt)
        } else {
            this.props.showChangeArrow(c.task)
        }
    }

    changeDate = async (t) => {
        // console.log('task to change date :>> ', t);
        // console.log('objEtapaSelectata :>> ', this.props.objEtapaSelectata);


        let task = t

        let dataTask = new Date(new Utils().ParseDataFromSql(t.pana_cand_data))

        let dataEtapa = new Date(this.props.objTaskSelectat.pana_cand_data)

        dataTask = dataTask.setDate(dataTask.getDate())


        dataTask = new Date(dataTask)

        let dateToUpdate = new Utils().transformDataForSql(dataTask)

        // console.log('dataTask :>> ', dateToUpdate);

        task.pana_cand_data = dateToUpdate + 'T00:00:00'



        if (dataTask > dataEtapa) {
            // console.log('no puedo :>> ');
        } else {

            let update = await this.ws.update('taskuri', { pana_cand_data: dateToUpdate }, { id: t.id })

            // console.log('update :>> ', update);

            if (update.Succes) {
                this.props.updateTasks(task)
            }
        }
    }

    removeEventMouseDown = () => {

        document.getElementById('taskID').removeEventListener('mousemove', this.mousePosition, true)

        this.changeDate(this.taskData)

        console.log('this.taskData :>> ', this.taskData);
    }

    changeSize = (t, id, idD) => {

        let el = document.getElementById(id)

        console.log('el :>> ', el);

        this.taskData = t
        this.elData = el


        document.getElementById('taskID').addEventListener('mousemove', this.mousePosition, true)

        // document.getElementById('etapaID').removeEventListener('mousemove' , this.mousePosition, true)

        document.getElementById('taskID').addEventListener('mouseup', this.removeEventMouseDown, true)
        // let elSize = el.getBoundingClientRect()

        // console.log('elSize :>> ', elSize);
    }

    mousePosition = (e) => {

        console.log('mousePosition :>> ', e);

        let u = new Utils()

        let candData = { ...this.taskData.cand_data }

        let task = { ...this.taskData }

        let el = this.elData


        let objTaskInfo = this.props.objTaskSelectat

        let dataStart = new Date(u.ParseDataFromSql(objTaskInfo.cand_data))

        let dataFinish = new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data))

        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime())

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24))

        let dateList = Math.ceil(dayDifference / this.props.screenLimit)


        console.log('dayDifference :>> ', dateList);

        let elContainer = document.getElementById('taskID')

        let elContainerWidth = elContainer.getBoundingClientRect().width


        let tenP = elContainerWidth * 10 / 100

        var posX = e.clientX;
        var posY = e.clientY;

        let elSize = el.getBoundingClientRect()




        if (elSize.right + tenP < posX) {
            console.log('elSize more :>> ', elSize);
            console.log('el :>> ', el);


            el.style.width = (elSize.width + tenP) * 100 / elContainerWidth + '%'
            el.style.maxWidth = elContainerWidth - 20 + 'px'

            console.log('el.style.width :>> ', el.style.width);
            let dataTask = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))

            dataTask = dataTask.setDate(dataTask.getDate() + dateList)


            dataTask = new Date(dataTask)

            let dateToUpdate = new Utils().transformDataForSql(dataTask)
            task.pana_cand_data = dateToUpdate + 'T00:00:00'



            this.taskData = task


        }
        else if (elSize.right > (posX + tenP)) {



            el.style.width = (elSize.width - tenP) * 100 / elContainerWidth + '%'

            let dataTask = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))

            dataTask = dataTask.setDate(dataTask.getDate() - dateList)


            dataTask = new Date(dataTask)

            let dateToUpdate = new Utils().transformDataForSql(dataTask)
            task.pana_cand_data = dateToUpdate + 'T00:00:00'




            this.taskData = task



            if (elSize.width < 150) {
                el.style.width = 150 + 'px'

                task.pana_cand_data = candData

                this.taskData = task


            }
        }




        //    console.log('posX :>> ', posX);
        //    console.log('posY :>> ', posY);
    }
    showEdit = (t) => {

        let el = document.getElementById(t)
        el.style.display = 'block'
        setTimeout(() => {
            el.style.display = 'none'
        }, 5000)
    }

    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }

    showAvatar = (t) => {


        if (t.utilizator_responsabil.length > 0) {
            if (t.utilizator_responsabil[0].poza) {
                return (


                    <Avatar
                        onMouseEnter={() => { this.props.showUserTag(t) }}
                        onMouseLeave={() => { this.props.hideUserTag(t) }}
                        style={{ display: 'inline-block', marginLeft: 10, width: 36, height: 36, marginTop: 2 }} src={this.ws.adresaMedia + '/Angajati/' + t.utilizator_responsabil[0].poza} />


                )
            } else {


                return (


                    <Avatar
                        onMouseEnter={() => { this.props.showUserTag(t) }}
                        onMouseLeave={() => { this.props.hideUserTag(t) }}
                        style={{ display: 'inline-block', width: 36, height: 36, textAlign: 'center', marginLeft: 10, marginTop: 2, backgroundColor: new Utils().culoriUtilizatori(t.utilizator_responsabil[0].id) }}>
                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                        <span style={{marginTop:'20%', display:'block'}}>{this.numeAvatar(t.utilizator_responsabil[0].nume)} </span>
                        
                    </Avatar>

                )

            }
        } else {
            return ''
        }


    }

    arataData = (d) => {

        let u = new Utils();

        if (this.props.dictionary.date === 'en') {
            return u.dataPrescurtataEngNoYear(u.ParseDataFromSql(d))
        } else {
            return u.dataPrescurtataRomanaNoYear(u.ParseDataFromSql(d))
        }


    }

    hideSlider = (ev) => {
        if (this.state.whatChange) {
            let objTaskSelectat = this.props.objTaskSelectat
            let dataStart = new Date(objTaskSelectat.cand_data)
            let dataFinish = new Date(this.state.taskToChangeDate.pana_cand_data)

            let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

            let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

            let dateList = Math.ceil(dayDifference / this.props.screenLimit)

            let counter = Math.floor(dayDifference / dateList)

            // console.warn('counter last date :', counter);

            // console.warn('date list', dateList)

            // console.warn('ev.target.value :', ev.target.value);

            if (ev.target.value > counter) {
                let dif = ev.target.value - counter

                dataFinish = dataFinish.setDate(dataFinish.getDate() + (dif * dateList))

            } else {
                let dif = counter - ev.target.value
                dataFinish = dataFinish.setDate(dataFinish.getDate() - (dif * dateList))
            }

            // console.warn('dataFinish :', new Date(dataFinish));
            this.setState({ slideValue: ev.target.value }, async () => {
                await this.props.changePanaCandData(new Date(dataFinish))
            })


        } else {
            let objTaskSelectat = this.props.objTaskSelectat
            let dataStart = new Date(objTaskSelectat.cand_data)
            let dataFinish = new Date(this.state.taskToChangeDate.cand_data)

            let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

            let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

            let dateList = Math.ceil(dayDifference / this.props.screenLimit)

            let counter = dayDifference !== 0 ? Math.floor(dayDifference / dateList) : 0

            // console.warn('counter :', counter);

            // console.warn('date list', dateList)

            // console.warn('ev.target.value :', ev.target.value);



            if (ev.target.value > counter) {
                let dif = ev.target.value - counter

                let difDateList = counter !== 0 ? dif * dateList : dif

                // console.warn('difDate')

                dataFinish = dataFinish.setDate(dataFinish.getDate() + (difDateList))

            } else {
                let dif = counter - ev.target.value

                let difDateList = counter !== 0 ? dif * dateList : dif

                dataFinish = dataFinish.setDate(dataFinish.getDate() - (difDateList))
            }

            // console.warn('dataFinish :', new Date(dataFinish));
            this.setState({ slideValue: ev.target.value }, async () => {
                await this.props.changeCandData(new Date(dataFinish))
            })
        }

        let slider = document.getElementById(ev.target.id)

        slider.style.display = 'none'
    }

    changeSlideVal = async (ev) => {
        this.setState({ slideValue: ev.target.value })
    }

    openSlide = (t, careData, sId, objTask) => {
        if (careData === 'pana_cand_data') {


            let dataStart = new Date(objTask.cand_data)
            let dataFinish = new Date(t.pana_cand_data)

            let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

            let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

            let dateList = Math.ceil(dayDifference / this.props.screenLimit)

            let counter = Math.floor(dayDifference / dateList)

            // console.log('counter :', counter);

            let slider = document.getElementById(sId)

            slider.style.display = 'block'
            slider.style.bottom = (t.bottom - 20) + 'px'



            this.setState({
                slideValue: counter,
                whatChange: true,
                taskToChangeDate: t
            }, () => {
                this.props.editTask(t, this.props.objEtapaSelectata, true)
            })
        } else {

            let dataStart = new Date(objTask.cand_data)
            let dataFinish = new Date(t.cand_data)

            let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

            let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

            let dateList = Math.ceil(dayDifference / this.props.screenLimit)

            let counter = dayDifference !== 0 ? Math.floor(dayDifference / dateList) : 0

            // console.log('counter :', counter);

            let slider = document.getElementById(sId)

            slider.style.display = 'block'
            slider.style.bottom = (t.bottom - 20) + 'px'

            // console.warn('coounter :', counter);
            // console.warn('timeDiff', timeDiff)
            // console.warn('day dif', dayDifference)
            // console.warn('datelist', dateList)


            this.setState({
                slideValue: counter,
                whatChange: false,
                taskToChangeDate: t
            }, () => {
                this.props.editTask(t, this.props.objEtapaSelectata, true)
            })
        }
    }






    listHead = () => {

        let u = new Utils()

        let objTaskInfo = this.props.objTaskSelectat

        let dataStart = new Date(u.ParseDataFromSql(objTaskInfo.cand_data))

        let dataStart2 = new Date(objTaskInfo.cand_data)
        let dataFinish = new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data))

        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime())

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24))

        let today = new Date()
        today = today.setHours(0)
        today = new Date(today).setMinutes(0)
        today = new Date(today).setSeconds(0)
        today = new Date(today).setMilliseconds(0)
        today = new Date(today)

        let dateList = Math.ceil(dayDifference / this.props.screenLimit)

        // console.log('dateList :', dateList);

        let counter = Math.floor(dayDifference / dateList)

        let head = []

        if (this.props.dictionary.date === 'en') {
            for (let i = 0; i <= counter; i++) {

                let listedDate;
                let listedDate2;

                if (i === 0) {
                    listedDate = dataStart.setDate(dataStart.getDate() + i)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                } else {
                    listedDate = dataStart.setDate(dataStart.getDate() + dateList)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                }


                let newDate = new Date(listedDate)
                newDate = newDate.setHours(0)
                newDate = new Date(newDate).setMinutes(0)
                newDate = new Date(newDate).setSeconds(0)
                newDate = new Date(newDate).setMilliseconds(0)
                newDate = new Date(newDate)

                let newDate2 = new Date(listedDate2)
                newDate2 = newDate2.setHours(0)
                newDate2 = new Date(newDate2).setMinutes(0)
                newDate2 = new Date(newDate2).setSeconds(0)
                newDate2 = new Date(newDate2).setMilliseconds(0)
                newDate2 = new Date(newDate2)

                let dateBackground = 'transparent'
                let dateTextColor = '#7f7a7a'

                if (i % 2 === 1) {
                    dateBackground = '#eff0f1'
                }

                // if (today >= newDate && today < newDate2) {

                //     // console.log('today--------- :', today);

                //     listedDate = today
                //     dateBackground = '#65cc5e'
                //     dateTextColor = 'white'
                // }


                if (i === counter) {

                    head.push(<div style={{ color: 'black', textAlign: 'right' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataEng(dataFinish)}</div>)

                } else {

                    if (newDate.getTime() !== today.getTime()) {
                        if (i === 0) {
                            head.push(<div style={{ color: 'black', textAlign: 'left' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataEng(listedDate)}</div>)

                        } else {

                            head.push(<div style={{ color: 'black' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataEngNoYear(listedDate)}</div>)
                        }

                    }

                }
            }
        } else {
            for (let i = 0; i <= counter; i++) {
                let listedDate;
                let listedDate2;

                if (i === 0) {
                    listedDate = dataStart.setDate(dataStart.getDate() + i)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                } else {
                    listedDate = dataStart.setDate(dataStart.getDate() + dateList)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                }

                let newDate = new Date(listedDate)
                newDate = newDate.setHours(0)
                newDate = new Date(newDate).setMinutes(0)
                newDate = new Date(newDate).setSeconds(0)
                newDate = new Date(newDate).setMilliseconds(0)
                newDate = new Date(newDate)

                let newDate2 = new Date(listedDate2)
                newDate2 = newDate2.setHours(0)
                newDate2 = new Date(newDate2).setMinutes(0)
                newDate2 = new Date(newDate2).setSeconds(0)
                newDate2 = new Date(newDate2).setMilliseconds(0)
                newDate2 = new Date(newDate2)

                let dateBackground = 'transparent'
                let dateTextColor = '#7f7a7a'

                if (i % 2 === 1) {
                    dateBackground = '#eff0f1'
                }

                // if (today >= newDate && today < newDate2) {

                //     // console.log('today--------- :', today);
                //     // console.log('newDate2------- :', newDate2);
                //     listedDate = today
                //     dateBackground = '#65cc5e'
                //     dateTextColor = 'white'
                // }


                if (i === counter) {
                    // console.log(' level 1 -----------:');


                    head.push(<div style={{ color: 'black', textAlign: 'right' }} className='pm-proiect-integral-date-head' key={`headData${i + 1}`}>{u.dataPrescurtataRomana(dataFinish)}</div>)


                } else {

                    if (newDate.getTime() !== today.getTime()) {

                        if (i === 0) {
                            head.push(<div style={{ color: 'black', textAlign: 'left' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataRomana(listedDate)}</div>)

                        } else {
                            head.push(<div style={{ color: 'black' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataRomanaNoYear(listedDate)}</div>)

                        }

                    }

                }
            }
        }
        return <div style={{ display: 'table', width: '100%' }}>
            {head}
        </div>
    }


    listBody = () => {
        let u = new Utils();

        let objEtapa = this.props.objEtapaSelectata

        let objTaskInfo = this.props.objTaskSelectat

        let listSubtaskuri = this.props.listSubTaskuri

        let subTaskuri = listSubtaskuri.filter(t => t.id_task_parent === objTaskInfo.id)

        console.log('objTaskInfo :>> ', objTaskInfo);

        subTaskuri = subTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) <= new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data)) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data))))


        console.log('subTaskuri :>> ', subTaskuri);


        let dataStart = new Date(u.ParseDataFromSql(objTaskInfo.cand_data))
        let dataFinish = new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data))

        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

        let dateList = Math.ceil(dayDifference / this.props.screenLimit)


        let nrZile = Math.floor(dayDifference / dateList)


        let counter = subTaskuri.length



        objTaskInfo.x = ((window.innerWidth * 98) / 2) / 100
        objTaskInfo.clientWidth = (window.innerWidth * 98) / 100

        let sumaEtapa = dataFinish.getTime() - dataStart.getTime()



        // console.log('objTaskInfo :', objTaskInfo);
        let taskuriBottom = -30

        let subSubtask = []


        for (let i = 0; i < counter; i++) {


            let dataSfTask = new Date(u.ParseDataFromSql(subTaskuri[i].pana_cand_data))
            let dataInceputTask = new Date(u.ParseDataFromSql(subTaskuri[i].cand_data))



            let sumaTask = dataSfTask.getTime() - dataInceputTask.getTime()

            let newMargin = dataInceputTask.getTime() - dataStart.getTime()

            // console.log('dataInceputTask :', dataInceputTask);
            // console.log('dataStart :', dataStart);

            let procentTask = Math.floor((newMargin / sumaEtapa) * 100)

            subTaskuri[i].marginLeft = procentTask

            let newProcentTask = Math.floor((sumaTask / sumaEtapa) * 100)

            subTaskuri[i].procent = newProcentTask

            subTaskuri[i].left = ((subTaskuri[i].marginLeft + (subTaskuri[i].procent / 2)) * objTaskInfo.clientWidth) / 100

            subTaskuri[i].clientWidth = objTaskInfo.clientWidth * (subTaskuri[i].procent) / 100

            subTaskuri[i].clientLeft = (subTaskuri[i].marginLeft * objTaskInfo.clientWidth) / 100
            let procentFilter = subTaskuri.filter(t => t.id !== subTaskuri[i].id)
            procentFilter = procentFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) > new Date(u.ParseDataFromSql(subTaskuri[i].cand_data)))


            if (procentFilter.length > 0) {
                taskuriBottom += -30 * (i + 1)

            } else {
                taskuriBottom = -60
            }

            subTaskuri[i].bottom = taskuriBottom

            let ipo = Math.sqrt(Math.pow((objTaskInfo.x - subTaskuri[i].left), 2) + Math.pow(-subTaskuri[i].bottom, 2))

            subTaskuri[i].degree = - ((objTaskInfo.x - subTaskuri[i].left) / ipo) * (180 / 3.14)

            let subtaskuri = this.props.listSubTaskuri

            // console.log('listSubtaskuri :', listSubtaskuri);

            let filterSubtaskuri = subtaskuri.filter(t => t.id_task_parent === subTaskuri[i].id)

            // console.log('filterSubtaskuri :', filterSubtaskuri);


            filterSubtaskuri = filterSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(subTaskuri[i].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(subTaskuri[i].pana_cand_data)))

            // console.log('filterSubtaskuri :', filterSubtaskuri);

            let counter2 = filterSubtaskuri.length

            let subTaskuriBottom = -20

            for (let j = 0; j < counter2; j++) {
                let dataSfSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].pana_cand_data))
                let dataInceputSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data))



                let sumaSubTask = dataSfSubTask.getTime() - dataInceputSubTask.getTime()

                let newMarginSubtask = dataInceputSubTask.getTime() - dataInceputTask.getTime()


                let procentSubtask = Math.floor((newMarginSubtask / sumaTask) * 100)

                filterSubtaskuri[j].marginLeft = procentSubtask

                let newProcentSubtask = Math.floor((sumaSubTask / sumaTask) * 100)

                filterSubtaskuri[j].procent = newProcentSubtask

                filterSubtaskuri[j].left = ((filterSubtaskuri[j].marginLeft + (filterSubtaskuri[j].procent / 2)) * subTaskuri[i].clientWidth) / 100 + subTaskuri[i].clientLeft

                let subTaskProcFilter = filterSubtaskuri.filter(t => t.id !== filterSubtaskuri[j].id)
                subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data)))

                // console.log('subTaskProcFilter :', subTaskProcFilter);

                if (subTaskProcFilter.length > 0) {

                    taskuriBottom += -10 * (j + 1)
                    subTaskuriBottom = -30 * (j + 1)

                } else {
                    subTaskuriBottom = -30

                }
                // console.log('taskuriBottom :', taskuriBottom);

                filterSubtaskuri[j].bottom = subTaskuriBottom

                let ipo = Math.sqrt(Math.pow((subTaskuri[i].left - filterSubtaskuri[j].left), 2) + Math.pow(-filterSubtaskuri[j].bottom, 2))

                filterSubtaskuri[j].degree = -((subTaskuri[i].left - filterSubtaskuri[j].left) / ipo) * (180 / 3.14)

                subSubtask.push(filterSubtaskuri[j])
                let subSubtaskuri = this.props.listSubTaskuri

                // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                let filterSubSubtaskuri = subSubtaskuri.filter(t => t.id_task_parent === filterSubtaskuri[j].id)

                // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                filterSubSubtaskuri = filterSubSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubtaskuri[j].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(filterSubtaskuri[j].pana_cand_data)))



                let counter3 = filterSubSubtaskuri.length

                let subTaskuriBottom1 = -30

                for (let q = 0; q < counter3; q++) {
                    let dataSfSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].pana_cand_data))
                    let dataInceputSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data))



                    let sumaSubTask1 = dataSfSubTask1.getTime() - dataInceputSubTask1.getTime()

                    let newMarginSubtask1 = dataInceputSubTask1.getTime() - dataInceputSubTask.getTime()


                    let procentSubtask1 = Math.floor((newMarginSubtask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].marginLeft = procentSubtask1

                    let newprocentSubtask1 = Math.floor((sumaSubTask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].procent = newprocentSubtask1

                    filterSubSubtaskuri[q].left = ((filterSubSubtaskuri[q].marginLeft + (filterSubSubtaskuri[q].procent / 2)) * filterSubtaskuri[j].clientWidth) / 100 + filterSubtaskuri[j].clientLeft


                    filterSubSubtaskuri[q].clientWidth = filterSubtaskuri[j].clientWidth * (filterSubSubtaskuri[q].procent) / 100

                    filterSubSubtaskuri[q].clientLeft = (filterSubSubtaskuri[q].marginLeft * filterSubtaskuri[j].clientWidth) / 100

                    let subTaskProcFilter = filterSubSubtaskuri.filter(t => t.id !== filterSubSubtaskuri[q].id)
                    subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data)))

                    // console.log('subTaskProcFilter :', subTaskProcFilter);



                    if (subTaskProcFilter.length > 0) {




                        taskuriBottom += -30

                        subTaskuriBottom += -30

                        subTaskuriBottom1 += -30 * (q + 1)

                    } else {
                        subTaskuriBottom1 = -30



                    }
                    // console.log('taskuriBottom :', taskuriBottom);

                    filterSubSubtaskuri[q].bottom = subTaskuriBottom1

                    let ipo = Math.sqrt(Math.pow((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left), 2) + Math.pow(-filterSubSubtaskuri[q].bottom, 2))

                    filterSubSubtaskuri[q].degree = -((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left) / ipo) * (180 / 3.14)

                    listSubtaskuri.push(filterSubSubtaskuri[q])


                    let subSubtaskuri2 = this.props.listSubTaskuri

                    // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                    let filterSubSubtaskuri2 = subSubtaskuri2.filter(t => t.id_task_parent === filterSubSubtaskuri[q].id)

                    // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                    filterSubSubtaskuri2 = filterSubSubtaskuri2.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubSubtaskuri[q].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(filterSubSubtaskuri[q].pana_cand_data)))



                    let counter4 = filterSubSubtaskuri2.length

                    let subTaskuriBottom2 = -30

                    for (let k = 0; k < counter4; k++) {
                        let dataSfSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].pana_cand_data))
                        let dataInceputSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data))



                        let sumaSubTask2 = dataSfSubTask2.getTime() - dataInceputSubTask2.getTime()

                        let newMarginSubtask2 = dataInceputSubTask2.getTime() - dataInceputSubTask1.getTime()


                        let procentSubtask2 = Math.floor((newMarginSubtask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].marginLeft = procentSubtask2

                        let newprocentSubtask2 = Math.floor((sumaSubTask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].procent = newprocentSubtask2

                        filterSubSubtaskuri2[k].left = ((filterSubSubtaskuri2[k].marginLeft + (filterSubSubtaskuri2[k].procent / 2)) * filterSubSubtaskuri[q].clientWidth) / 100 + filterSubSubtaskuri[q].clientLeft


                        filterSubSubtaskuri2[k].clientWidth = filterSubSubtaskuri[q].clientWidth * (filterSubSubtaskuri2[k].procent) / 100

                        filterSubSubtaskuri2[k].clientLeft = (filterSubSubtaskuri2[k].marginLeft * filterSubSubtaskuri[q].clientWidth) / 100

                        let subTaskProcFilter2 = filterSubSubtaskuri2.filter(t => t.id !== filterSubSubtaskuri2[k].id)
                        subTaskProcFilter2 = subTaskProcFilter2.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data)))

                        // console.log('subTaskProcFilter :', subTaskProcFilter);



                        if (subTaskProcFilter2.length > 0) {




                            taskuriBottom += -30

                            subTaskuriBottom += -30

                            subTaskuriBottom1 += -30

                            subTaskuriBottom2 = -30 * (k + 1)

                        } else {


                            subTaskuriBottom2 = -30

                        }
                        // console.log('taskuriBottom :', taskuriBottom);

                        filterSubSubtaskuri2[k].bottom = subTaskuriBottom2

                        let ipo = Math.sqrt(Math.pow((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left), 2) + Math.pow(- filterSubSubtaskuri2[k].bottom, 2))

                        filterSubSubtaskuri2[k].degree = -((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left) / ipo) * (180 / 3.14)

                        listSubtaskuri.push(filterSubSubtaskuri2[k])

                    }
                }
            }


        }

        console.log('subTaskuri :', subTaskuri);


        let container = <div style={{ width: '100%', height: '100%', minHeight: 100, marginTop: 30 }}>
            <div id='taskID' style={{ width: `98%`, boxSizing: 'border-box', margin: 'auto', position: 'relative', textAlign: 'left' }}>
                {/* <span>
                                                                                                        <input className='slider-date' 
                                                                                                                        type='range' 
                                                                                                                        id={`slider-task-date`}
                                                                                                                        style={{
                                                                                                                            display:'none',
                                                                                                                            position:'absolute',
                                                                                                                            left:0,
                                                                                                                            right:0,
                                                                                                                            margin:'auto',
                                                                                                                            width:'100%',
                                                                                                                            bottom:-15
                                                                                                                        }}
                                                                                                                        min='0' 
                                                                                                                        max={`${nrZile}`}
                                                                                                                        step={1}
                                                                                                                        name='pm-slider'
                                                                                                                        onMouseUp={(ev)=>{this.hideSlider(ev)}}
                                                                                                                        onChange={(ev) => {this.changeSlideVal(ev) }} 
                                                                                                                        value={this.state.slideValue} />
            </span> */}
                {/* <div  onMouseEnter={()=>{this.showEdit(`edit-task`)}}className='pm-proiect-integral-etapa'
                    style={{
                        boxSizing: 'border-box',

                        width: '98%',
                        backgroundColor: objTaskInfo.color,


                        borderBottomLeftRadius: 30,
                        borderTopLeftRadius: 30,
                        borderBottomRightRadius: 30,
                        borderTopRightRadius: 30
                    }}>  */}

                <div id='pm-change-subetapa-view'>
                    <h3 style={{ marginBottom: 20, width: 'fit-content' }}>

    
                        
                        {this.props.siteMapArray && this.props.siteMapArray .map((s,idx)=>{
                            return(
                            <span key={idx} onClick={()=>{this.props.goToTask(s)}} style={{color:'blue'}}> {idx > 0 && ' / '}  {s.titlu}</span>
                            )
                        })}
                        
                        {/* <span > {this.props.siteMapArray.length >  0 && ' / '} {objTaskInfo.titlu}</span> */}
                        </h3>

                    {/* <div style={{
                        marginTop: 13,
                        marginLeft: 10
                    }} >


                        <span style={{verticalAlign:'super'}}>Mod Vizionare</span>
                        <i onClick={() => { this.changeViewOption('think') }} style={{cursor:'pointer'}} className='material-icons'>emoji_objects</i>
                        <i style={{ color: 'blue', cursor:'pointer' }} onClick={() => { this.changeViewOption('gantt') }} className='material-icons'>clear_all</i>
                        <i onClick={() => { this.changeViewOption('tabel') }} style={{cursor:'pointer'}} className='material-icons'>table_chart</i>



                    </div> */}

                </div>

                {subTaskuri.length === 0 &&
                    <div>
                        <span style={{ fontWeight: 400, fontSize: 12, verticalAlign: '-webkit-baseline-middle' }}>{this.dictionary.proiecte.noTaskInEtapa} </span>

                    </div>
                }


                {/* <span className='pm-proiect-integral-etapa-nume' style={{ marginBottom: 20 }} >{objTaskInfo.titlu}</span> */}
                {/* <i onClick={()=>{this.props.editTask(this.props.objTaskSelectat, this.props.objEtapaSelectata)}} id={`edit-task`} className='material-icons pm-edit-task'>create</i> */}
                {subTaskuri.map((t, idxT) => {
                    return (
                        // <Hidden key={`taskuri${idxT}`} mdDown>
                        <div key={`taskuri${idxT}`}
                            id={`subtaskuri${idxT}`}
                            // onMouseEnter={() => { this.showEdit(`edit-task-etapa${t.id}`) }} 
                            className='pm-task-etapa-integral'
                            onMouseEnter={() => { this.props.showTag(t) }}
                            onMouseLeave={() => { this.props.hideTag(t) }}
                            style={{
                                minWidth: 150,
                                width: `${t.procent}%`,
                                position: 'relative',
                                marginTop: 20,
                                // bottom: t.bottom,
                                marginLeft: `${t.marginLeft > 85 ? 85 : t.marginLeft}%`,
                                backgroundColor: t.color
                            }}>
                            {/* <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span> */}
                            {t.procent_completare > 0 &&
                                <div onClick={() => { this.props.goToTask(t) }} style={{
                                    backgroundColor: 'rgb(225 225 224)',
                                    position: 'absolute',
                                    width: (100 - t.procent_completare) + '%',
                                    height: '100%',
                                    right: 0,
                                    top: 0,

                                    borderTopRightRadius: 18,
                                    borderBottomRightRadius: 18
                                }}>
                                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                        {t.subtaskuri_trecute > 0 && t.in_lucru &&
                                            <i style={{
                                                color: 'white',
                                                fontSize: 12,
                                                backgroundColor: 'red',
                                                borderRadius: '50%',
                                                padding: 1,
                                                position: 'absolute',
                                                bottom: 0,
                                                left: -5
                                            }} className='material-icons'>priority_high</i>

                                        }
                                    </div>
                                </div>
                            }

                            <div style={{ position: 'relative', width: '100%', display: 'flex' }}>
                                <div className='etapa-tag' style={{
                                    position: 'absolute', display: t.show_tag ? 'block' : 'none', top: 35,
                                    zIndex:1200,
                                    left: -25, color: 'black'
                                }}>
                                    <div className='etapa-tag-container' style={{ position: 'relative' }}>


                                        <div style={{
                                            position: 'absolute',
                                            top: -11,
                                            left: 70
                                        }} className='triangle-up'>

                                        </div>

                                        <h4 style={{ marginBottom: 5 }}> {t.titlu} </h4>
                                        <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.duration}:{new Utils().dataPrescurtataRomana(t.cand_data)} - {new Utils().dataPrescurtataRomana(t.pana_cand_data)} </span>
                                        {t.subtaskuri.length > 0 &&


                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.gradDeCompletare}:{t.procent_completare}% </span>
                                        }

                                        {t.statusul === 'Finalizat' &&
                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.completedAt}:{new Utils().dataPrescurtataRomana(t.cand_finalizat)}</span>
                                        }



                                        <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.subtasksNumber}:{t.subtaskuri.length} </span>



                                        {t.subtaskuri_trecute > 0 && t.in_lucru &&
                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}><i style={{
                                                color: 'white',
                                                fontSize: 12,
                                                backgroundColor: 'red',
                                                borderRadius: '50%',
                                                padding: 1,

                                            }} className='material-icons'>priority_high</i> {t.subtaskuri_trecute} {t.subtaskuri_trecute > 1 ? this.dictionary.proiecte.subtasksTermenDepasit : this.dictionary.proiecte.subtaskTermenDepasit}</span>
                                        }
                                    </div>

                                </div>
                                <i onClick={() => { this.props.finalizeazaTask(t) }} style={{
                                    backgroundColor: 'white',
                                    cursor: 'pointer',
                                    color: t.statusul === 'Finalizat' ? 'rgb(24, 166, 59)' : 'black',
                                    borderRadius: 20,
                                    padding: 3,
                                    verticalAlign: 'middle',
                                    display: t.show_tag ? 'inline-flex' : 'none'
                                }} className='material-icons'>check_circle_outline</i>

                                <span onClick={() => { this.props.goToTask(t) }} style={{ cursor: 'pointer', display: 'inline-flex' }} className='pm-task-etapa-titlu'>{t.titlu}</span>

                            </div>


                            {!t.show_change_arrow &&
                                <div style={{ position: 'absolute', right: 3, top: 0, zIndex: 1002, cursor: 'pointer', display: 'flex' }}>






                                    {/* {t.show_tag && */}
                                    <TaskMenu
                                        callBack={this.callBack}
                                        menuItems={[{ id: 1, name:this.dictionary.proiecte.manageTask, task: t }, 
                                        // { id: 2, name: 'Modifica Interactiv Datele', task: t }
                                    ]}
                                    />
                                    {/* } */}

                                    {this.showAvatar(t)}





                                </div>
                            }

                            {t.utilizator_responsabil.length > 0 &&

                                <div className='etapa-tag' style={{
                                    position: 'absolute', display: t.utilizator_responsabil[0].show_tag_subtask ? 'block' : 'none', top: 35,
                                    right: -70, color: 'white', zIndex: 1003
                                }}>
                                    <div className='user-tag-container' style={{ position: 'relative', textAlign: 'left' }}>


                                        <div style={{
                                            position: 'absolute',
                                            top: -11,
                                            left: '45%',
                                            borderBottomColor: 'rgb(75 75 75)',

                                        }} className='triangle-up'>

                                        </div>

                                        <h4 style={{ marginBottom: 5, fontSize: 14 }}>{t.utilizator_responsabil[0].nume} </h4>
                                        <span style={{ marginTop: 5, display: "block", fontSize: 12 }}>{this.dictionary.proiecte.department}:{t.utilizator_responsabil[0].nume_departament}</span>


                                    </div>


                                </div>
                            }


                            {t.show_change_arrow &&
                                <div style={{ position: 'absolute', right: 3, top: 0, zIndex: 1002, cursor: 'pointer', display: 'flex' }}>



                                    <IconButton
                                        style={{ padding: 1, marginTop: 3, backgroundColor: 'white' }}
                                        aria-controls='simple-menu' aria-haspopup="true" onClick={() => { this.props.hideChangeArrow(t) }}>
                                        <i style={{ fontSize: 33, color: 'black' }} className='material-icons'>
                                            check_circle_outline
                                    </i>
                                    </IconButton>





                                </div>
                            }


                            {t.show_change_arrow &&

                                <i onMouseUp={() => { this.removeEventMouseDown() }} id={`datachangeSubtask${idxT}`} onMouseDown={() => { this.changeSize(t, `subtaskuri${idxT}`, `datachangeSubtask${idxT}`) }} className='material-icons forward-arrow'>forward</i>
                            }



                            {/* <span onClick={() => { this.props.goToTask(t) }} style={{ backgroundColor: t.color }} className='pm-task-etapa-titlu'>{t.titlu}</span> */}
                            {/* <i onClick={() => { this.props.editTask(t, this.props.objEtapaSelectata) }} style={{ display: 'block' }} className='material-icons pm-edit-task'>create</i> */}
                            {/* <i style={{
                                    color: '#adadad',
                                    position: 'absolute',
                                    display: this.props.userView ? 'none' : 'block',
                                    left: -25,
                                    fontSize: 30,
                                    top: 2
                                }} onClick={() => { this.openSlide(t, 'cand_data', `slider-task-date`, this.props.objTaskSelectat) }} className='material-icons '>arrow_back</i> */}
                            {/* <i style={{
                                    color: '#adadad',
                                    position: 'absolute',
                                    display: this.props.userView ? 'none' : 'block',
                                    fontSize: 30,
                                    top: 2,
                                    right: -25
                                }} onClick={() => { this.openSlide(t, 'pana_cand_data', `slider-task-date`, this.props.objTaskSelectat) }} className='material-icons '>arrow_forward</i> */}

                            {/* <div className='pm-task-etapa-line' style={{
                                                              height:- t.bottom || 0,
                                                              top: t.bottom || 0,
                                                               transform: `skew(${t.degree}deg)`}}>

                                                 </div> */}
                            {/* {subSubtask.filter(st => st.id_task_parent === t.id).map((st, idxSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSt}`} style={{width:`${st.procent}%`, 
                                                                                                           
                                                                                                    bottom:st.bottom,
                                                                                                    left:`${st.marginLeft}%`, 
                                                                                                    backgroundColor:st.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(st)}} style={{backgroundColor:st.color}} className='pm-sub-task-titlu'>{st.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height:- st.bottom || 0,
                                                                                                                top: st.bottom || 0,
                                                                                                                transform: `skew(${st.degree}deg)`}}>

                                                                                            </div>
                                                                                            {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSSt}`} style={{width:`${sst.procent}%`, 
                                                                                                           
                                                                                                    bottom:sst.bottom,
                                                                                                    left:`${sst.marginLeft}%`, 
                                                                                                    backgroundColor:sst.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(sst)}} style={{backgroundColor:sst.color}} className='pm-sub-task-titlu'>{sst.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height: -sst.bottom || 0,
                                                                                                                top: sst.bottom || 0,
                                                                                                                transform: `skew(${sst.degree}deg)`}}>

                                                                                            </div>
                                                                                            {listSubtaskuri.filter(ssst => ssst.id_task_parent === sst.id).map((ssst, idxSSSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSSSt}`} style={{width:`${ssst.procent}%`, 
                                                                                                           
                                                                                                    bottom:ssst.bottom,
                                                                                                    left:`${ssst.marginLeft}%`, 
                                                                                                    backgroundColor:ssst.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(ssst)}} style={{backgroundColor:ssst.color}} className='pm-sub-task-titlu'>{ssst.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height: -ssst.bottom || 0,
                                                                                                                top: ssst.bottom || 0,
                                                                                                                transform: `skew(${ssst.degree}deg)`}}>

                                                                                            </div>
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )} 
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )} 
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )}   */}


                        </div>
                        // </Hidden>
                    )
                })}

                <div style={{ marginTop: 20 }}>
                    <Button style={{ display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={() => { this.props.insertSubtask(this.props.objTaskSelectat) }}  >
                        <i style={{verticalAlign:'sub'}} className='material-icons pm-round-button-text'>add</i>
                        {this.dictionary.proiecte.newTask}
                            </Button>
                </div>

                {/* {subTaskuri.map((t,idxT)=>{
                        return(
                            <Hidden  key={`taskuri${idxT}`} smUp>
                            <div  onMouseEnter={()=>{this.showEdit(`edit-task-etapa${t.id}`)}} className='pm-task-etapa-integral'  
                                                        style={{width:`90%`, 
                                                                position:'relative',
                                                                marginTop:10,
                                                                marginBottom:5,
                                                              backgroundColor:t.color,
                                                              height:'fit-content'
                                                              }}>
                                                               <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span> 
                                                              <span onClick={()=>{this.props.goToTask(t)}} style={{backgroundColor:t.color}} className='pm-task-etapa-titlu'>{t.titlu}</span>
                                                              <i onClick={()=>{this.props.editTask(t, this.props.objEtapaSelectata)}} id={`edit-task-etapa${t.id}`} className='material-icons pm-edit-task'>create</i>
                                                           

                                                              </div>

                                                 {subSubtask.filter(st => st.id_task_parent === t.id).map((st, idxSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSt}`} style={{width:`${st.procent}%`, 
                                                                                                           
                                                                                                    bottom:st.bottom,
                                                                                                    left:`${st.marginLeft}%`, 
                                                                                                    backgroundColor:st.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(st)}} style={{backgroundColor:st.color}} className='pm-sub-task-titlu'>{st.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height:- st.bottom || 0,
                                                                                                                top: st.bottom || 0,
                                                                                                                transform: `skew(${st.degree}deg)`}}>

                                                                                            </div>
                                                                                            {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSSt}`} style={{width:`${sst.procent}%`, 
                                                                                                           
                                                                                                    bottom:sst.bottom,
                                                                                                    left:`${sst.marginLeft}%`, 
                                                                                                    backgroundColor:sst.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(sst)}} style={{backgroundColor:sst.color}} className='pm-sub-task-titlu'>{sst.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height: -sst.bottom || 0,
                                                                                                                top: sst.bottom || 0,
                                                                                                                transform: `skew(${sst.degree}deg)`}}>

                                                                                            </div>
                                                                                            {listSubtaskuri.filter(ssst => ssst.id_task_parent === sst.id).map((ssst, idxSSSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSSSt}`} style={{width:`${ssst.procent}%`, 
                                                                                                           
                                                                                                    bottom:ssst.bottom,
                                                                                                    left:`${ssst.marginLeft}%`, 
                                                                                                    backgroundColor:ssst.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(ssst)}} style={{backgroundColor:ssst.color}} className='pm-sub-task-titlu'>{ssst.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height: -ssst.bottom || 0,
                                                                                                                top: ssst.bottom || 0,
                                                                                                                transform: `skew(${ssst.degree}deg)`}}>

                                                                                            </div>
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )} 
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )} 
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )}  
                                     
                                             
                        
                        </Hidden>
                        )
                    })} */}
            </div>
            {/* </div> */}
        </div >


        return container
    }


    listBodyTable = () => {
        let u = new Utils();

        let objEtapa = this.props.objEtapaSelectata

        let objTaskInfo = this.props.objTaskSelectat

        let listSubtaskuri = this.props.listSubTaskuri

        let subTaskuri = listSubtaskuri.filter(t => t.id_task_parent === objTaskInfo.id)

        subTaskuri = subTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) <= new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data)) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data))))




        let dataStart = new Date(u.ParseDataFromSql(objTaskInfo.cand_data))
        let dataFinish = new Date(u.ParseDataFromSql(objTaskInfo.pana_cand_data))

        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

        let dateList = Math.ceil(dayDifference / this.props.screenLimit)


        let nrZile = Math.floor(dayDifference / dateList)


        let counter = subTaskuri.length



        objTaskInfo.x = ((window.innerWidth * 98) / 2) / 100
        objTaskInfo.clientWidth = (window.innerWidth * 98) / 100

        let sumaEtapa = dataFinish.getTime() - dataStart.getTime()



        // console.log('objTaskInfo :', objTaskInfo);
        let taskuriBottom = -30

        let subSubtask = []


        for (let i = 0; i < counter; i++) {


            let dataSfTask = new Date(u.ParseDataFromSql(subTaskuri[i].pana_cand_data))
            let dataInceputTask = new Date(u.ParseDataFromSql(subTaskuri[i].cand_data))



            let sumaTask = dataSfTask.getTime() - dataInceputTask.getTime()

            let newMargin = dataInceputTask.getTime() - dataStart.getTime()

            // console.log('dataInceputTask :', dataInceputTask);
            // console.log('dataStart :', dataStart);

            let procentTask = Math.floor((newMargin / sumaEtapa) * 100)

            subTaskuri[i].marginLeft = procentTask > 80 ? 80 : procentTask

            let newProcentTask = Math.floor((sumaTask / sumaEtapa) * 100)

            subTaskuri[i].procent = newProcentTask

            subTaskuri[i].left = ((subTaskuri[i].marginLeft + (subTaskuri[i].procent / 2)) * objTaskInfo.clientWidth) / 100

            subTaskuri[i].clientWidth = objTaskInfo.clientWidth * (subTaskuri[i].procent) / 100

            subTaskuri[i].clientLeft = (subTaskuri[i].marginLeft * objTaskInfo.clientWidth) / 100
            let procentFilter = subTaskuri.filter(t => t.id !== subTaskuri[i].id)
            procentFilter = procentFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) > new Date(u.ParseDataFromSql(subTaskuri[i].cand_data)))


            if (procentFilter.length > 0) {
                taskuriBottom += -30 * (i + 1)

            } else {
                taskuriBottom = -60
            }

            subTaskuri[i].bottom = taskuriBottom

            let ipo = Math.sqrt(Math.pow((objTaskInfo.x - subTaskuri[i].left), 2) + Math.pow(-subTaskuri[i].bottom, 2))

            subTaskuri[i].degree = - ((objTaskInfo.x - subTaskuri[i].left) / ipo) * (180 / 3.14)

            let subtaskuri = this.props.listSubTaskuri

            // console.log('listSubtaskuri :', listSubtaskuri);

            let filterSubtaskuri = subtaskuri.filter(t => t.id_task_parent === subTaskuri[i].id)

            // console.log('filterSubtaskuri :', filterSubtaskuri);


            filterSubtaskuri = filterSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(subTaskuri[i].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(subTaskuri[i].pana_cand_data)))

            // console.log('filterSubtaskuri :', filterSubtaskuri);

            let counter2 = filterSubtaskuri.length

            let subTaskuriBottom = -20

            for (let j = 0; j < counter2; j++) {
                let dataSfSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].pana_cand_data))
                let dataInceputSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data))



                let sumaSubTask = dataSfSubTask.getTime() - dataInceputSubTask.getTime()

                let newMarginSubtask = dataInceputSubTask.getTime() - dataInceputTask.getTime()


                let procentSubtask = Math.floor((newMarginSubtask / sumaTask) * 100)

                filterSubtaskuri[j].marginLeft = procentSubtask

                let newProcentSubtask = Math.floor((sumaSubTask / sumaTask) * 100)

                filterSubtaskuri[j].procent = newProcentSubtask

                filterSubtaskuri[j].left = ((filterSubtaskuri[j].marginLeft + (filterSubtaskuri[j].procent / 2)) * subTaskuri[i].clientWidth) / 100 + subTaskuri[i].clientLeft

                let subTaskProcFilter = filterSubtaskuri.filter(t => t.id !== filterSubtaskuri[j].id)
                subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data)))

                // console.log('subTaskProcFilter :', subTaskProcFilter);

                if (subTaskProcFilter.length > 0) {

                    taskuriBottom += -10 * (j + 1)
                    subTaskuriBottom = -30 * (j + 1)

                } else {
                    subTaskuriBottom = -30

                }
                // console.log('taskuriBottom :', taskuriBottom);

                filterSubtaskuri[j].bottom = subTaskuriBottom

                let ipo = Math.sqrt(Math.pow((subTaskuri[i].left - filterSubtaskuri[j].left), 2) + Math.pow(-filterSubtaskuri[j].bottom, 2))

                filterSubtaskuri[j].degree = -((subTaskuri[i].left - filterSubtaskuri[j].left) / ipo) * (180 / 3.14)

                subSubtask.push(filterSubtaskuri[j])
                let subSubtaskuri = this.props.listSubTaskuri

                // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                let filterSubSubtaskuri = subSubtaskuri.filter(t => t.id_task_parent === filterSubtaskuri[j].id)

                // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                filterSubSubtaskuri = filterSubSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubtaskuri[j].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(filterSubtaskuri[j].pana_cand_data)))



                let counter3 = filterSubSubtaskuri.length

                let subTaskuriBottom1 = -30

                for (let q = 0; q < counter3; q++) {
                    let dataSfSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].pana_cand_data))
                    let dataInceputSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data))



                    let sumaSubTask1 = dataSfSubTask1.getTime() - dataInceputSubTask1.getTime()

                    let newMarginSubtask1 = dataInceputSubTask1.getTime() - dataInceputSubTask.getTime()


                    let procentSubtask1 = Math.floor((newMarginSubtask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].marginLeft = procentSubtask1

                    let newprocentSubtask1 = Math.floor((sumaSubTask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].procent = newprocentSubtask1

                    filterSubSubtaskuri[q].left = ((filterSubSubtaskuri[q].marginLeft + (filterSubSubtaskuri[q].procent / 2)) * filterSubtaskuri[j].clientWidth) / 100 + filterSubtaskuri[j].clientLeft


                    filterSubSubtaskuri[q].clientWidth = filterSubtaskuri[j].clientWidth * (filterSubSubtaskuri[q].procent) / 100

                    filterSubSubtaskuri[q].clientLeft = (filterSubSubtaskuri[q].marginLeft * filterSubtaskuri[j].clientWidth) / 100

                    let subTaskProcFilter = filterSubSubtaskuri.filter(t => t.id !== filterSubSubtaskuri[q].id)
                    subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data)))

                    // console.log('subTaskProcFilter :', subTaskProcFilter);



                    if (subTaskProcFilter.length > 0) {




                        taskuriBottom += -30

                        subTaskuriBottom += -30

                        subTaskuriBottom1 += -30 * (q + 1)

                    } else {
                        subTaskuriBottom1 = -30



                    }
                    // console.log('taskuriBottom :', taskuriBottom);

                    filterSubSubtaskuri[q].bottom = subTaskuriBottom1

                    let ipo = Math.sqrt(Math.pow((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left), 2) + Math.pow(-filterSubSubtaskuri[q].bottom, 2))

                    filterSubSubtaskuri[q].degree = -((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left) / ipo) * (180 / 3.14)

                    listSubtaskuri.push(filterSubSubtaskuri[q])


                    let subSubtaskuri2 = this.props.listSubTaskuri

                    // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                    let filterSubSubtaskuri2 = subSubtaskuri2.filter(t => t.id_task_parent === filterSubSubtaskuri[q].id)

                    // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                    filterSubSubtaskuri2 = filterSubSubtaskuri2.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubSubtaskuri[q].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(filterSubSubtaskuri[q].pana_cand_data)))



                    let counter4 = filterSubSubtaskuri2.length

                    let subTaskuriBottom2 = -30

                    for (let k = 0; k < counter4; k++) {
                        let dataSfSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].pana_cand_data))
                        let dataInceputSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data))



                        let sumaSubTask2 = dataSfSubTask2.getTime() - dataInceputSubTask2.getTime()

                        let newMarginSubtask2 = dataInceputSubTask2.getTime() - dataInceputSubTask1.getTime()


                        let procentSubtask2 = Math.floor((newMarginSubtask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].marginLeft = procentSubtask2

                        let newprocentSubtask2 = Math.floor((sumaSubTask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].procent = newprocentSubtask2

                        filterSubSubtaskuri2[k].left = ((filterSubSubtaskuri2[k].marginLeft + (filterSubSubtaskuri2[k].procent / 2)) * filterSubSubtaskuri[q].clientWidth) / 100 + filterSubSubtaskuri[q].clientLeft


                        filterSubSubtaskuri2[k].clientWidth = filterSubSubtaskuri[q].clientWidth * (filterSubSubtaskuri2[k].procent) / 100

                        filterSubSubtaskuri2[k].clientLeft = (filterSubSubtaskuri2[k].marginLeft * filterSubSubtaskuri[q].clientWidth) / 100

                        let subTaskProcFilter2 = filterSubSubtaskuri2.filter(t => t.id !== filterSubSubtaskuri2[k].id)
                        subTaskProcFilter2 = subTaskProcFilter2.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data)))

                        // console.log('subTaskProcFilter :', subTaskProcFilter);



                        if (subTaskProcFilter2.length > 0) {




                            taskuriBottom += -30

                            subTaskuriBottom += -30

                            subTaskuriBottom1 += -30

                            subTaskuriBottom2 = -30 * (k + 1)

                        } else {


                            subTaskuriBottom2 = -30

                        }
                        // console.log('taskuriBottom :', taskuriBottom);

                        filterSubSubtaskuri2[k].bottom = subTaskuriBottom2

                        let ipo = Math.sqrt(Math.pow((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left), 2) + Math.pow(- filterSubSubtaskuri2[k].bottom, 2))

                        filterSubSubtaskuri2[k].degree = -((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left) / ipo) * (180 / 3.14)

                        listSubtaskuri.push(filterSubSubtaskuri2[k])

                    }
                }
            }


        }

        // console.log('subTaskuri :', subTaskuri);


        let container = <div style={{ width: '100%', height: '100%', minHeight: 100, marginTop: 30 }}>
            <div id='taskID' style={{ width: `98%`, boxSizing: 'border-box', margin: 'auto', position: 'relative', textAlign: 'left' }}>
                {/* <span>
                                                                                                        <input className='slider-date' 
                                                                                                                        type='range' 
                                                                                                                        id={`slider-task-date`}
                                                                                                                        style={{
                                                                                                                            display:'none',
                                                                                                                            position:'absolute',
                                                                                                                            left:0,
                                                                                                                            right:0,
                                                                                                                            margin:'auto',
                                                                                                                            width:'100%',
                                                                                                                            bottom:-15
                                                                                                                        }}
                                                                                                                        min='0' 
                                                                                                                        max={`${nrZile}`}
                                                                                                                        step={1}
                                                                                                                        name='pm-slider'
                                                                                                                        onMouseUp={(ev)=>{this.hideSlider(ev)}}
                                                                                                                        onChange={(ev) => {this.changeSlideVal(ev) }} 
                                                                                                                        value={this.state.slideValue} />
            </span> */}
                {/* <div  onMouseEnter={()=>{this.showEdit(`edit-task`)}}className='pm-proiect-integral-etapa'
                    style={{
                        boxSizing: 'border-box',

                        width: '98%',
                        backgroundColor: objTaskInfo.color,


                        borderBottomLeftRadius: 30,
                        borderTopLeftRadius: 30,
                        borderBottomRightRadius: 30,
                        borderTopRightRadius: 30
                    }}>  */}


                <div id='pm-change-subetapa-view'>
                    <h3 style={{ marginBottom: 20, width: 'fit-content' }}>{objTaskInfo.titlu}</h3>

                    {/* <div style={{
                        marginTop: 13,
                        marginLeft: 10
                    }} >


                        <span style={{verticalAlign:'super'}}>Mod Vizionare</span>
                        <i onClick={() => { this.changeViewOption('think') }} style={{cursor:'pointer'}} className='material-icons'>emoji_objects</i>
                        <i onClick={() => { this.changeViewOption('gantt') }} style={{cursor:'pointer'}} className='material-icons'>clear_all</i>
                        <i style={{ color: 'blue', cursor:'pointer' }} onClick={() => { this.changeViewOption('tabel') }} className='material-icons'>table_chart</i>



                    </div> */}

                </div>





                {subTaskuri.length === 0 &&
                    <div>
                        <span style={{ fontWeight: 400, fontSize: 12, verticalAlign: '-webkit-baseline-middle' }}>{this.dictionary.proiecte.noTaskInEtapa}</span>

                    </div>
                }


                <Grid style={{marginTop:20}} container>
                    <Grid style={{ padding: '0 10px 0 15px' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <TabelTask
                            etapa={this.props.objTaskSelectat}
                            showUserTag={this.props.showUserTag}
                            hideUserTag={this.props.hideUserTag}
                            headData={[this.dictionary.proiecte.taskName, this.dictionary.proiecte.dateStart, this.dictionary.proiecte.dateFinish]}
                            taskuri={subTaskuri}
                            changeTask={this.props.changeTask}
                            updateTaskTitle={this.props.updateTaskTitle}
                            dataStartChange={this.props.dataStartChange}
                            dtDataStart={this.props.dtDataStart}
                            dataFinishChange={this.props.dataFinishChange}
                            dtDataFinish={this.props.dtDataFinish}
                            getTaskDates={this.props.getTaskDates}
                            isUtlizatorOpen={this.props.isUtlizatorOpen}
                            closeUtilizator={this.props.closeUtilizator}
                            listUsers={this.props.listUsers}
                            userClick={this.props.userClick}
                        />

                    </Grid>

                    <Grid style={{marginTop:20}} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        {subTaskuri.map((t, idxT) => {
                            return (
                                // <Hidden key={`taskuri${idxT}`} mdDown>
                                <div key={`taskuri${idxT}`}
                                    id={`subtaskuri${idxT}`}
                                    // onMouseEnter={() => { this.showEdit(`edit-task-etapa${t.id}`) }} 
                                    className='pm-task-etapa-integral'
                                    onMouseEnter={() => { this.props.showTag(t) }}
                                    onMouseLeave={() => { this.props.hideTag(t) }}
                                    style={{
                                        minWidth: 100,
                                        width: `${t.procent}%`,
                                        position: 'relative',
                                        marginTop: 20,
                                        // bottom: t.bottom,
                                        marginLeft: `${t.marginLeft > 80 ? 80 : t.marginLeft}%`,
                                        backgroundColor: t.color
                                    }}>
                                    {/* <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span> */}
                                    {t.procent_completare > 0 &&
                                        <div onClick={() => { this.props.goToTask(t) }} style={{
                                            backgroundColor: 'rgb(225 225 224)',
                                            position: 'absolute',
                                            width: (100 - t.procent_completare) + '%',
                                            height: '100%',
                                            right: 0,
                                            top: 0,

                                            borderTopRightRadius: 18,
                                            borderBottomRightRadius: 18
                                        }}>
                                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                                {t.subtaskuri_trecute > 0 && t.in_lucru &&
                                                    <i style={{
                                                        color: 'white',
                                                        fontSize: 12,
                                                        backgroundColor: 'red',
                                                        borderRadius: '50%',
                                                        padding: 1,
                                                        position: 'absolute',
                                                        bottom: 0,
                                                        left: -5
                                                    }} className='material-icons'>priority_high</i>

                                                }
                                            </div>
                                        </div>
                                    }



                                </div>
                                // </Hidden>
                            )
                        })}

                    </Grid>

                </Grid>


                {/* <span className='pm-proiect-integral-etapa-nume' style={{ marginBottom: 20 }} >{objTaskInfo.titlu}</span> */}
                {/* <i onClick={()=>{this.props.editTask(this.props.objTaskSelectat, this.props.objEtapaSelectata)}} id={`edit-task`} className='material-icons pm-edit-task'>create</i> */}


                <div style={{ marginTop: 20 }}>
                    <Button style={{ display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={() => { this.props.insertSubtask(this.props.objTaskSelectat) }}  >
                        <i style={{verticalAlign:'sub'}} className='material-icons pm-round-button-text'>add</i>
                        {this.dictionary.proiecte.newTask}
                            </Button>
                </div>

                {/* {subTaskuri.map((t,idxT)=>{
                        return(
                            <Hidden  key={`taskuri${idxT}`} smUp>
                            <div  onMouseEnter={()=>{this.showEdit(`edit-task-etapa${t.id}`)}} className='pm-task-etapa-integral'  
                                                        style={{width:`90%`, 
                                                                position:'relative',
                                                                marginTop:10,
                                                                marginBottom:5,
                                                              backgroundColor:t.color,
                                                              height:'fit-content'
                                                              }}>
                                                               <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span> 
                                                              <span onClick={()=>{this.props.goToTask(t)}} style={{backgroundColor:t.color}} className='pm-task-etapa-titlu'>{t.titlu}</span>
                                                              <i onClick={()=>{this.props.editTask(t, this.props.objEtapaSelectata)}} id={`edit-task-etapa${t.id}`} className='material-icons pm-edit-task'>create</i>
                                                           

                                                              </div>

                                                 {subSubtask.filter(st => st.id_task_parent === t.id).map((st, idxSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSt}`} style={{width:`${st.procent}%`, 
                                                                                                           
                                                                                                    bottom:st.bottom,
                                                                                                    left:`${st.marginLeft}%`, 
                                                                                                    backgroundColor:st.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(st)}} style={{backgroundColor:st.color}} className='pm-sub-task-titlu'>{st.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height:- st.bottom || 0,
                                                                                                                top: st.bottom || 0,
                                                                                                                transform: `skew(${st.degree}deg)`}}>

                                                                                            </div>
                                                                                            {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSSt}`} style={{width:`${sst.procent}%`, 
                                                                                                           
                                                                                                    bottom:sst.bottom,
                                                                                                    left:`${sst.marginLeft}%`, 
                                                                                                    backgroundColor:sst.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(sst)}} style={{backgroundColor:sst.color}} className='pm-sub-task-titlu'>{sst.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height: -sst.bottom || 0,
                                                                                                                top: sst.bottom || 0,
                                                                                                                transform: `skew(${sst.degree}deg)`}}>

                                                                                            </div>
                                                                                            {listSubtaskuri.filter(ssst => ssst.id_task_parent === sst.id).map((ssst, idxSSSt)=>{
                                                                                  return(
                                                                                    <div  className='pm-sub-task-integral'  key={`subTaskuri${idxSSSt}`} style={{width:`${ssst.procent}%`, 
                                                                                                           
                                                                                                    bottom:ssst.bottom,
                                                                                                    left:`${ssst.marginLeft}%`, 
                                                                                                    backgroundColor:ssst.color}}>
                                                                                                    <span onClick={()=>{this.props.goToTask(ssst)}} style={{backgroundColor:ssst.color}} className='pm-sub-task-titlu'>{ssst.titlu}</span>
                                                                                                                
                                                                                        <div className='pm-task-etapa-line' style={{
                                                                                                                height: -ssst.bottom || 0,
                                                                                                                top: ssst.bottom || 0,
                                                                                                                transform: `skew(${ssst.degree}deg)`}}>

                                                                                            </div>
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )} 
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )} 
                                                                                    </div>
                                                                                  )
                                                                                     
                                                                                        
                                                                              } )}  
                                     
                                             
                        
                        </Hidden>
                        )
                    })} */}
            </div>
            {/* </div> */}
        </div >


        return container
    }


    changeViewOption = (tip) => {
        this.props.changeViewOption(tip)
    }

    render() {
        return (
            <div style={{ width: '100%', position: 'relative', backgroundColor: 'white', padding: 20 }}>
                <Divider style={{ width: '100%' }} />

                <div style={{ display: this.props.displayHead === 1 ? 'none' : 'table' }} className='pm-proiect-integral-head'>

                    {!this.props.tableView &&
                        this.listHead()}

                    {this.props.tableView &&
                        <Grid container>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>

                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                {this.listHead()}
                            </Grid>
                        </Grid>
                    }

                </div>
                <div style={{ display: 'flex', justifyContent: this.props.displayInapoi === 1 ? 'space-between' : 'flex-end', marginBottom: 20, padding: 15 }}>
                    {/* <Button style={{ display: this.props.displayInapoi === 1 ? 'inline-flex' : 'none' }} onClick={() => {this.props.changeView(false,this.props.objEtapaSelectata)}} className="pm-inapoi-button">
                        <i className='material-icons pm-round-button-text'>keyboard_arrow_left</i>
                     Inapoi
                    </Button>
                    <Button style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex' }} onClick={() => { this.props.insertSubtask(this.props.objTaskSelectat) }} className="pm-adauga-button">
                        <i className='material-icons pm-round-button-text'>add</i>
                        Adauga Subtask
                    </Button> */}


                </div>

                {/* <h3 className='pm-title'>{this.props.objEtapaSelectata.denumire}</h3> */}
                <div style={{ position: 'relative' }}>
                    {this.props.tableView &&
                        this.listBodyTable()
                    }
                    {this.props.ganttView &&
                        this.listBody()
                    }
                    {/* <svg style={{position:'absolute', width:'100vw', height:'50vh', left:0, top:0}}>
                {this.state.drawSvg}
              </svg> */}
                </div>

            </div>
        );
    }
}//end class



GanttTaskuriFullView.propType = {
    objEtapaSelectata: PropTypes.object,
    objTaskSelectat: PropTypes.object,
    screenLimit: PropTypes.number,
    dictionary: PropTypes.object,
    listSubtaskuri: PropTypes.array,
    editTask: PropTypes.func,
    goToTask: PropTypes.func
}